import React from "react";
import {
    List, ListItem, ListItemText, Grid, Divider, Snackbar
} from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import {BASE_URL_MESSENGER_API, URL_CONTACT_AVATAR} from "../../Const";
import {ImageLoader} from "./ImageLoader";
import {TimeUtil} from "../../utils/TimeUtil";
import {ContactRepository,} from "../../Repository/messenger/ContactRepository";
import {Link} from "react-router-dom";

import { StylesProvider, jssPreset } from "@mui/styles";
import { create } from "jss";
import rtl from "jss-rtl";
import {DialogRepository} from "../../Repository/messenger/DialogRepository";

// RTL configuration for this component only
const jss = create({ plugins: [...jssPreset().plugins, rtl()] });

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export class ContactListComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            channelList: [],
            openSnackbar: false,
            message: "",
            snackbarType: "success"
        };
    }

    componentDidMount() {
        const cached = ContactRepository.getAll();
        if (cached?.length) {
            this.setState({ channelList: cached });
        }
        this.fetchContactList();
    }

    fetchContactList = () => {
        fetch(BASE_URL_MESSENGER_API + 'syncContacts', {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem("pwa_messenger_token"),
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                phone_numbers: "0",
                user_agent: "pwa"
            })
        })
            .then(res => res.json())
            .then(results => {
                if (results.code === "200") {
                    ContactRepository.saveContacts(results.data);
                    this.setState({ channelList: results.data });
                }
            })
            .catch(() => console.log("Error loading contacts"));
    };

    render() {
        if (!localStorage.getItem("pwa_messenger_token")) {
            window.location.assign('messenger/verify');
        }

        const handleCloseSnackbar = () => {
            this.setState({ openSnackbar: false });
        };

        return (
            <StylesProvider jss={jss}>
                <div style={{ direction: 'rtl' }}>
                    <List>
                        {this.state.channelList.map((item) => (
                            <ListItem
                                key={item.id}
                                button
                                component={Link}
                                to={`/messenger/chat?chat_id=${item.chat_id}`}
                            >
                                <Grid container alignItems="center">
                                    <Grid item xs={2}>
                                        <ImageLoader
                                            url={URL_CONTACT_AVATAR + item.avatar}
                                            thumbnail=""
                                            width={50}
                                            height={50}
                                        />
                                    </Grid>

                                    <Grid item xs={10}>
                                        <ListItemText
                                            primary={
                                                <p style={{
                                                    fontWeight: 'bold',
                                                    fontSize: 14,
                                                    margin: 0,
                                                    overflow: 'hidden',
                                                    whiteSpace: 'nowrap',
                                                    textOverflow: 'ellipsis',
                                                    textAlign: 'right'
                                                }}>
                                                    {item.name || item.phone}
                                                </p>
                                            }
                                            secondary={
                                                <>
                                                    <p style={{
                                                        color: '#999',
                                                        fontSize: 12,
                                                        margin: 0,
                                                        textAlign: 'right'
                                                    }}>
                                                        آخرین بازدید: {TimeUtil.convertTimestampTojalali(item.last_seen)}
                                                    </p>
                                                    {item.bio && (
                                                        <p style={{
                                                            color: '#ccc',
                                                            fontSize: 12,
                                                            margin: '4px 0 0',
                                                            overflow: 'hidden',
                                                            whiteSpace: 'nowrap',
                                                            textOverflow: 'ellipsis',
                                                            textAlign: 'right'
                                                        }}>
                                                            {item.bio}
                                                        </p>
                                                    )}
                                                </>
                                            }
                                        />
                                    </Grid>

                                    <Grid item xs={12}>
                                        <Divider style={{ marginTop: 8 }} />
                                    </Grid>
                                </Grid>
                            </ListItem>
                        ))}
                    </List>

                    <Snackbar open={this.state.openSnackbar} autoHideDuration={6000} onClose={handleCloseSnackbar}>
                        <Alert onClose={handleCloseSnackbar} severity={this.state.snackbarType}>
                            {this.state.message}
                        </Alert>
                    </Snackbar>
                </div>
            </StylesProvider>
        );
    }
}
